// Per-root chat attribution + merge for compare mode (design D8). Pure.
// The caller generates compareTurnId (e.g. crypto.randomUUID()) and passes it in.

export function tagUserTurn(text, rootIds, compareTurnId) {
  return { role: "user", content: text, _rootIds: [...rootIds], _compareTurnId: compareTurnId };
}

export function tagAssistantTurn(text, rootId, markers = {}) {
  return { ...markers, role: "assistant", content: text, _rootId: rootId };
}

// Merge per-root persisted threads into one display array:
// - assistant turns tagged with their owning rootId
// - user turns sharing a metadata.compareTurnId collapse to one (tagged _rootIds
//   = every root that had it); user turns without a shared id stay per root
// - ordered by created_at (stable on ties)
export function mergeThreads(threadsByRoot) {
  const entries = [];
  for (const [rootId, rows] of Object.entries(threadsByRoot || {})) {
    for (const r of rows || []) entries.push({ rootId, row: r, seq: entries.length });
  }
  entries.sort((x, y) => {
    const tx = Date.parse(x.row.created_at),
      ty = Date.parse(y.row.created_at);
    const ax = Number.isNaN(tx) ? Infinity : tx,
      ay = Number.isNaN(ty) ? Infinity : ty;
    return ax - ay || x.seq - y.seq;
  });

  const out = [];
  const sharedByTurn = new Map(); // compareTurnId -> index in `out`
  for (const { rootId, row } of entries) {
    const turnId = row.metadata?.compareTurnId;
    if (row.role === "user" && turnId) {
      const at = sharedByTurn.get(turnId);
      if (at != null) {
        out[at]._rootIds.push(rootId);
        continue;
      }
      sharedByTurn.set(turnId, out.length);
      out.push({ role: "user", content: row.content, _rootIds: [rootId], _compareTurnId: turnId });
    } else if (row.role === "user") {
      out.push({ role: "user", content: row.content, _rootId: rootId });
    } else {
      out.push({ role: "assistant", content: row.content, _rootId: rootId });
    }
  }
  return out;
}
